<template>
  <div class="task-dashboard">
    <!-- Statistics Cards -->
    <div class="task-stats" v-if="stats">
      <div class="stat-card">
        <div class="stat-label">Total Tasks</div>
        <div class="stat-value">{{ stats.total || 0 }}</div>
      </div>
      
      <div class="stat-card" v-for="(statusData, statusId) in stats.by_status" :key="`status-${statusId}`">
        <div class="stat-label">{{ statusData.name }}</div>
        <div class="stat-value" :style="{ color: getColorValue(statusData.color) }">
          {{ statusData.count }}
        </div>
      </div>
    </div>

    <!-- Task List with Search and View Toggle -->
    <task-cards
      title="My Tasks"
      :show-title="true"
      :searchable="true"
      create-button-text="Create Task"
      modal-name="dashboard-task-form-modal"
      @task-saved="handleTaskSaved"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TaskCards from './TaskCards.vue';

export default {
  name: 'TaskDashboard',

  components: {
    TaskCards
  },

  emits: ['create-task', 'edit-task'],

  computed: {
    ...mapState('tasks', ['stats'])
  },

  async mounted() {
    await this.loadStats();
  },

  methods: {
    async loadStats() {
      try {
        await this.$store.dispatch('tasks/fetchStats');
      } catch (error) {
        console.error('Error loading dashboard stats:', error);
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Failed to load task statistics. Please try again.'
        });
      }
    },

    handleTaskSaved() {
      // Refresh stats when a task is saved
      this.loadStats();
    },

    getColorValue(color) {
      const colorMap = {
        blue: '#3b82f6',
        yellow: '#eab308',
        green: '#22c55e',
        red: '#ef4444',
        orange: '#f97316',
        gray: '#6b7280'
      };
      return colorMap[color] || color;
    }
  }
};
</script>
